import { render, staticRenderFns } from "./BeforeUnloadModal.vue?vue&type=template&id=79e0fdc0"
import script from "./BeforeUnloadModal.vue?vue&type=script&lang=ts"
export * from "./BeforeUnloadModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports